import { useIdentity } from '~/composables/useIdentity'
import { resolvePostAuthDestination } from '~/utils/resolvePostAuthDestination'

export default defineNuxtRouteMiddleware((to) => {
  if (to.path !== '/dashboard') return

  const { isAuthenticated, roles } = useIdentity()

  // Below here: client-only, needs sessionStorage.
  if (import.meta.server) return

  if (isAuthenticated.value) {
    const destination = resolvePostAuthDestination(to, roles.value)
    if (destination !== '/dashboard') return navigateTo(destination, { replace: true })
  }
})
